<template>
  <Fragment>
    <template v-for="option in options">
      <slot name="item" v-bind="option">
        <a class="dropdown-item" role="button">
          <slot />
        </a>
      </slot>
    </template>
  </Fragment>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'
import { Fragment } from 'vue-fragment'

import { BaseDropdownInjectionKey } from './BaseDropdown.constants'

export default defineComponent({
  name: 'BaseDropdownContent',
  components: {
    Fragment
  },
  setup() {
    const { options } = inject(BaseDropdownInjectionKey)

    return {
      options
    }
  }
})
</script>
